module.exports = __webpack_public_path__ + "static/media/usb_cellular_step_3@2x.8c757c76.png";